import React from 'react'
import styles from './solution.scss'
import bill from '../../../common/images/solution/bill.jpg'
import bg_bill from '../../../common/images/solution/yd-bill.png'
import one from '../../../common/images/solution/01.png'
import two from '../../../common/images/solution/02.png'
import three from '../../../common/images/solution/03.png'
// import four from '../../../common/images/solution/04.png'
import circular from '../../../common/images/solution/circular.png'
import solutions from '../../../common/images/solution/solution.png'
import gather from '../../../common/images/solution/gather.png'
import fetch from '../../../common/images/solution/fetch.png'
import print from '../../../common/images/solution/print.png'
// import ticket from '../../../common/images/solution/ticket.png'
import one_x from '../../../common/images/solution/01-x.png'
import two_x from '../../../common/images/solution/02-x.png'
import three_x from '../../../common/images/solution/03-x.png'
// import fous_x from '../../../common/images/solution/04-x.png'

const Bill = (props) => {
  return <section className={styles['solution']}>
    <div className={styles['bill']}>
      <img src={bill} alt='bill' className={styles['bill_img']} />
      <img src={bg_bill} alt='bg_bill' className={styles['bg_bill_img']} />
      <div className={styles['bill-content']}>
        <h2>票据管理</h2>
        <p>化"繁"为"简"，为企业提供票财税一体化解决方案。</p>
      </div>
    </div>
    <div className={styles['industry-pain']}>
      <h3>行业痛点</h3>
      <ul>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={one} alt='01' className={styles['industry-one']} /></div>
            <h4>发票信息采集</h4>
          </div>
          <div className={styles['industry-p']}>
            <span></span>
            <p>
            多数财务人员仍需要人工识别和录入发票信息，时间成本高且出错几率大。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={two} alt='02' /></div>
            <h4>银行流水多</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s2']}></span>
            <p>
            银行流水非常多的时候，会计分分钟要崩溃，因为录凭证简直可以录到怀疑人生。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={three} alt='03' /></div>
            <h4>电子归档</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s3']}></span>
            <p>
            各种票据堆积成山，易丢易忘,而且不易保存。发票一张张打印也耗时费力。
            </p>
          </div>
        </li>
        {/* <li>
          <div className={styles['industry-h']}>
            <div><img src={four} alt='04' /></div>
            <h4>开票麻烦</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s4']}></span>
            <p>
            开票时需手动录入，繁琐且易出错。客户急要发票时，在外面根本无法开票。客户多时，无法批量开票。
            </p>
          </div>
        </li> */}
      </ul>
      <img src={solutions} alt='solutions' className={styles['solutions']} />
      <img src={circular} alt='circular' className={styles['circular']} />
    </div>
    <div className={styles['scheme']}>
      <h3>解决方法</h3>
      <p className={styles['scheme-wz']}>化“繁”为“简”，为企业提供票财税一体化解决方案。</p>
      <div className={styles['scheme_content']}>
        <img src={gather} alt='gather' className={styles['gather']} />
        <div>
          <img src={one_x} alt='one-x' className={styles['one-x']} />
          <h4>进销项发票批量采集</h4>
          <p>
          进销项发票批量获取，智能生成凭证（外贸、货代发票自动提取备注原币），可联查发票，有原件的电票自动生成凭证附件。
          </p>
        </div>
      </div>
      <div className={`${styles.scheme_content}`}>
        <div className={`${styles.scheme_two}`}>
          <img src={two_x} alt='two-x' className={styles['two-x']} />
          <h4>银行流水、回单智能取数</h4>
          <p>
          银行对账单可以直接导入（或从接口获取）,并自动生成凭证，可联查日记账。
          </p>
        </div>
        <img src={fetch} alt='fetch' className={styles['fetch']} />
      </div>
      <div className={styles['scheme_content']}>
        <img src={print} alt='print' className={styles['print']} />
        <div className={`${styles.scheme_three}`}>
          <img src={three_x} alt='three-x' className={styles['three-x']} />
          <h4>电子归档，批量打印</h4>
          <p>
          可将凭证（含附件、电票原件）、账簿、财务报表等按档案管理要 求生成PDF归档文件，减少账务移交、打印的成本。
          </p>
        </div>
      </div>
      {/* <div className={styles['scheme_content']}>
        <div className={`${styles.scheme_fous}`}>
          <img src={fous_x} alt='fous-x' className={styles['fous-x']} />
          <h4>在线开票</h4>
          <p>
          对发票库存、开票金额进行自动提醒预警。对于开票频率高以及对发票时效性要求高的客户，支持用户扫码开票或者小程序开票，链接微信端，随时随地满足各类开票需求。支持多家企业批量自动抄税清卡功能。
          </p>
        </div>
        <img src={ticket} alt='ticket' className={styles['ticket']} />
      </div> */}
    </div>
  </section>
}

export default Bill
